/* SECCO · efectos de scroll de la portada. Cada efecto en su función; FX.mount() se llama tras pintar la portada. */
window.FX = (() => {
  const rm = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const clamp = (v, a, b) => v < a ? a : v > b ? b : v;
  const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  const pad = k => (k < 10 ? "0" : "") + k;
  const prog = el => { const span = el.offsetHeight - innerHeight; return span > 0 ? clamp(-el.getBoundingClientRect().top / span, 0, 1) : 0; };
  let fns = [], queued = false, ios = [];
  const run = () => { queued = false; fns.forEach(f => f()); };
  addEventListener("scroll", () => { if (!queued && fns.length) { queued = true; requestAnimationFrame(run); } }, { passive: true });
  addEventListener("resize", () => requestAnimationFrame(run));
  const on = f => { fns.push(f); f(); };

  /* 01 · hojas que suben */
  function deck(root) {
    const d = root.querySelector("#deck"); if (!d) return;
    const slides = d.querySelectorAll(".sl"), imgs = d.querySelectorAll(".sl__img"), navs = d.querySelectorAll(".deck__nav a");
    const bar = d.querySelector(".deck__bar i"), cnt = d.querySelector(".deck__count b"), N = slides.length, HOLD = .28;
    navs.forEach((a, k) => a.addEventListener("click", e => {
      e.preventDefault(); const span = d.offsetHeight - innerHeight; const seg = k === 0 ? 0 : (k - 1) + 1.02;
      scrollTo({ top: d.offsetTop + span * clamp(seg / (N - .5), 0, 1), behavior: rm ? "auto" : "smooth" });
    }));
    if (rm) return;
    let last = -1;
    on(() => {
      const seg = prog(d) * (N - .5); let cur = 0;
      for (let k = 0; k < N; k++) {
        const tin = k === 0 ? 1 : ease(clamp((seg - (k - 1) - HOLD) / (1 - HOLD), 0, 1));
        const tout = k === N - 1 ? 0 : ease(clamp((seg - k - HOLD) / (1 - HOLD), 0, 1));
        slides[k].style.transform = `translate3d(0,${((1 - tin) * 100).toFixed(3)}%,0)`;
        slides[k].style.setProperty("--t", tin.toFixed(3)); slides[k].style.setProperty("--dim", (tout * .6).toFixed(3));
        imgs[k].style.transform = `translate3d(0,${(-(1 - tin) * 7 + tout * 6).toFixed(2)}%,0) scale(${(1 + (1 - tin) * .08 + tout * .04).toFixed(4)})`;
        if (tin > .5) cur = k;
      }
      if (bar) bar.style.transform = `scaleX(${clamp(seg / (N - 1), 0, 1).toFixed(4)})`;
      if (cur !== last) { last = cur; navs.forEach((a, j) => a.classList.toggle("is-on", j === cur)); if (cnt) cnt.textContent = pad(cur + 1); }
    });
  }

  /* 02 · manifiesto palabra a palabra + contadores */
  function manifesto(root) {
    const txt = root.querySelector("#mfTxt");
    if (txt && !txt.dataset.done) {
      txt.dataset.done = 1;
      const wrap = node => { const out = document.createDocumentFragment();
        node.childNodes.forEach(ch => {
          if (ch.nodeType === 3) ch.textContent.split(/(\s+)/).forEach(part => { if (!part) return; if (/^\s+$/.test(part)) { out.appendChild(document.createTextNode(part)); return; } const s = document.createElement("span"); s.className = "w"; s.textContent = part; out.appendChild(s); });
          else { const c = ch.cloneNode(false); c.appendChild(wrap(ch)); out.appendChild(c); }
        }); return out; };
      const f = wrap(txt); txt.innerHTML = ""; txt.appendChild(f);
      const words = txt.querySelectorAll(".w");
      if (rm) words.forEach(w => w.classList.add("on"));
      else on(() => { const r = txt.getBoundingClientRect(), vh = innerHeight; const p = clamp((vh * .85 - r.top) / (r.height + vh * .3), 0, 1); const lit = Math.round(p * words.length); words.forEach((w, i) => w.classList.toggle("on", i < lit)); });
    }
    const nums = root.querySelectorAll("[data-count]");
    const fmt = (n, dec) => dec ? (n / 100).toFixed(2).replace(".", ",") : String(n);
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return; io.unobserve(e.target);
      const el = e.target, to = +el.dataset.count, dec = el.hasAttribute("data-dec"), t0 = performance.now();
      if (rm) { el.textContent = fmt(to, dec); return; }
      (function step(now) { const k = clamp((now - t0) / 1500, 0, 1); el.textContent = fmt(Math.round(to * (1 - Math.pow(1 - k, 4))), dec); if (k < 1) requestAnimationFrame(step); })(t0);
    }), { threshold: .6 });
    nums.forEach(n => io.observe(n)); ios.push(io);
  }

  /* 03 · galería encadenada de palas */
  function drift(root) {
    const dr = root.querySelector(".drift"); if (!dr) return;
    const stage = dr.querySelector(".drift__stage"), frames = dr.querySelectorAll(".drift__f"), metas = dr.querySelectorAll(".drift__item"),
      dots = dr.querySelectorAll(".drift__dot"), glow = dr.querySelector(".drift__glow"), ghost = dr.querySelector(".drift__ghost"),
      count = dr.querySelector(".drift__count b"), bar = dr.querySelector(".drift__bar i"), total = frames.length;
    let cur = -1;
    dots.forEach((d, k) => d.addEventListener("click", () => { const span = dr.offsetHeight - innerHeight; scrollTo({ top: dr.offsetTop + span * ((k + .5) / total), behavior: "smooth" }); }));
    const set = i => {
      if (i === cur) return; cur = i;
      frames.forEach((f, k) => f.className = "drift__f" + (k === i ? " is-on" : k < i ? " is-prev" : ""));
      metas.forEach((m, k) => m.classList.toggle("is-on", k === i)); dots.forEach((d, k) => d.classList.toggle("is-on", k === i));
      glow.style.setProperty("--acc", frames[i].dataset.acc); ghost.textContent = pad(i + 1); count.textContent = pad(i + 1);
    };
    if (rm) { set(0); return; }
    on(() => { const p = prog(dr), raw = p * total, i = Math.min(total - 1, Math.floor(raw)); stage.style.setProperty("--sub", clamp(raw - i, 0, 1).toFixed(3)); if (bar) bar.style.transform = `scaleY(${p.toFixed(3)})`; set(i); });
  }

  /* 04 · foto que se abre */
  function opener(root) {
    const sec = root.querySelector("#opener"); if (!sec || rm) return;
    const stage = sec.querySelector(".lb__stage"), img = sec.querySelector(".lb__frame img");
    on(() => {
      const r = sec.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
      const p = prog(sec), k = ease(clamp(p / .62, 0, 1)), narrow = innerWidth < 700;
      stage.style.setProperty("--cy", ((1 - k) * (narrow ? 24 : 20)).toFixed(2) + "%");
      stage.style.setProperty("--cx", ((1 - k) * (narrow ? 14 : 36)).toFixed(2) + "%");
      stage.style.setProperty("--cr", ((1 - k) * 8).toFixed(1) + "px");
      stage.style.setProperty("--po", clamp(1 - k * 2.2, 0, 1).toFixed(3));
      stage.style.setProperty("--to", clamp((p - .6) / .22, 0, 1).toFixed(3));
      img.style.transform = `scale(${(1.28 - k * .28 + p * .04).toFixed(4)})`;
    });
  }

  /* 05 · comunidad en horizontal (anclada en ordenador, con el dedo en móvil) */
  function hscroll(root) {
    const sec = root.querySelector("#comunidad"), track = root.querySelector("#hsTrack"); if (!sec || !track) return;
    // los vídeos solo se descargan y se reproducen cuando se ven
    const vio = new IntersectionObserver(es => es.forEach(e => { const v = e.target;
      if (e.isIntersecting) { if (!v.src) v.src = v.dataset.src; v.play().catch(() => {}); } else if (v.src) v.pause(); }), { threshold: .35 });
    track.querySelectorAll("video[data-src]").forEach(v => vio.observe(v)); ios.push(vio);
    const progEl = sec.querySelector(".hs__prog i"), now = sec.querySelector(".hs__count b"), n = track.children.length;
    const wide = { matches: false }; let dist = 0;
    const size = () => { if (!wide.matches || rm) { sec.style.height = ""; dist = 0; track.style.transform = ""; return; } dist = Math.max(0, track.scrollWidth - innerWidth); sec.style.height = (innerHeight + dist) + "px"; };
    size(); addEventListener("resize", size); setTimeout(size, 600);
    on(() => {
      if (!wide.matches || rm) return;
      const p = prog(sec); track.style.transform = `translate3d(${(-p * dist).toFixed(1)}px,0,0)`;
      if (progEl) progEl.style.transform = `scaleX(${p.toFixed(4)})`;
      if (now) now.textContent = pad(Math.min(n, 1 + Math.floor(p * n)));
    });
  }

  /* 06 · muro de prensa */
  function wall(root) {
    const sec = root.querySelector("#prensa"), rows = sec ? sec.querySelectorAll(".bw__row") : []; if (!rows.length || rm) return;
    on(() => {
      const r = sec.getBoundingClientRect(), vh = innerHeight; if (r.bottom < 0 || r.top > vh) return;
      const p = (vh - r.top) / (vh + r.height);
      rows.forEach((row, i) => { const w = row.scrollWidth - innerWidth; const x = i % 2 ? -w * (1 - p) : -w * p; row.style.transform = `translate3d(${(x * .55).toFixed(1)}px,0,0)`; });
    });
  }

  /* parallax suave */
  function parallax(root) {
    if (rm) return; const list = [...root.querySelectorAll("[data-par]")];
    on(() => { const vh = innerHeight; list.forEach(el => { const r = el.parentNode.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; const p = (vh - r.top) / (vh + r.height); el.style.transform = `translate3d(0,${((p - .5) * -10).toFixed(2)}%,0) scale(1.08)`; }); });
  }

  function mount(root) {
    fns = []; ios.forEach(io => io.disconnect()); ios = [];
    deck(root); manifesto(root); drift(root); opener(root); hscroll(root); wall(root); parallax(root);
  }
  function clear() { fns = []; ios.forEach(io => io.disconnect()); ios = []; }
  return { mount, clear, prog };
})();
